import {Component, OnDestroy, ViewChild} from "@angular/core";
import {ConfigurationService} from "@fedeltapointofsale/data-client";
import {Router} from "@angular/router";
import {EntityImportAction, EntityImportActionResp} from "../entity-import.service";
import {first, Subscription, timer} from "rxjs";
import {
    EntityImportStatusAction,
    EntityImportStatusActionResp,
    EntityImportStatusService,
    ImportStatus
} from "../entity-import-status.service";
import {AppLayoutImportService} from "../app-layout-import.service";
import {FileUploadComponent} from "../../../shared/file/file-upload.component";

/**
 * Entity import
 */
@Component({
    selector: "wbo-app-layout-file-import-page",
    templateUrl: "./app-layout-file-import-page.component.html",
    styleUrls: ["./app-layout-file-import-page.component.scss"],
    providers: [AppLayoutImportService, EntityImportStatusService]
})
export class AppLayoutFileImportPageComponent implements OnDestroy {

    @ViewChild(FileUploadComponent) fileUploadComponent: FileUploadComponent;

    importing: boolean;
    success: boolean;
    started: boolean;
    errorImporting: boolean;

    percentageComplete: number = 0;

    importId: string;

    private subscription: Subscription;

    constructor(
        private configService: ConfigurationService,
        private router: Router,
        private appLayoutImportService: AppLayoutImportService,
        private entityImportStatusService: EntityImportStatusService) {
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    importFile(event: any): void {
        this.started = true;
        this.importing = true;

        this.appLayoutImportService.performAction(new EntityImportAction(event)).then((resp: EntityImportActionResp) => {
            this.importId = resp.id;
            this.initPoll(true);
        }).catch((error) => {
            setTimeout(() => {
                this.errorImporting = true;
                this.importing = false;
            });
            throw error;
        });

    }

    onCancel(): void {
        this.router.navigate([""], {replaceUrl: true});
    }

    private initPoll(delay?: boolean): void {
        this.subscription = timer(delay ? 3000 : 0).pipe(first()).subscribe(() => this.checkStatus());
    }

    private checkStatus(): void {
        this.entityImportStatusService.performAction(new EntityImportStatusAction(this.importId)).then((resp: EntityImportStatusActionResp) => {
            if (resp.status === ImportStatus.WAITING || resp.status === ImportStatus.PROCESSING) {
                this.initPoll(true);
            } else {
                this.importing = false;
                this.success = resp.status === ImportStatus.COMPLETE;
            }
            this.percentageComplete = resp.percentageComplete;
        }).catch((error) => {
            console.log("failed to check import status...");
            console.log(error);
            this.initPoll(true);
        });
    }

    private retry(): void {
        this.importing = false;
        this.success = false;
        this.started = false;
        this.errorImporting = false;
        this.percentageComplete = 0;

        this.fileUploadComponent.reset();
    }
}
